module.exports = __webpack_public_path__ + "static/media/Road turn left.2025345c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Road turn left.svg
// module id = 197
// module chunks = 0